<template>
    <div>
        <Sidebar></Sidebar>

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-create d-lg-inline-block"></div>

            <Header></Header>

            <section class="content create-due-content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-11 form-request-content-large">
                            <div class="request-title">
                                <h1>DUE : Créer</h1>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-10 form-request-content-large">
                          <ul class="breadcrumb-steps">
                            <li class="breadcrumb-steps__item success mobile-hide">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Création du modèle de DUE
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item success mobile-hide">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Paramétrage des bénéficiaires
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item success">
                              <span class="breadcrumb-steps__num"><i class='fas fa-check'></i></span>
                              <span class="breadcrumb-steps__descr">
                                Paramétrage des cotisations
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item active">
                              <span class="breadcrumb-steps__num">4</span>
                              <span class="breadcrumb-steps__descr">
                                Délais applicables
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item">
                              <span class="breadcrumb-steps__num">5</span>
                              <span class="breadcrumb-steps__descr">
                                Cas de dispense facultatifs
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">6</span>
                              <span class="breadcrumb-steps__descr">
                                Documents annexes
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">7</span>
                              <span class="breadcrumb-steps__descr">
                                Informations importantes
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">8</span>
                              <span class="breadcrumb-steps__descr">
                                Signature éléctronique
                              </span>
                            </li>
                          </ul>
                        </div>
                    </div>

                    <div class="row"></div>
                    <div class="col-md-10 form-request-content-large">
                        <div class="required-field-text">Champs obligatoires</div>
                        <div class="form-group">
                            <form
                                    name="exemption"
                                    method="post"
                                    enctype="multipart/form-data"
                                    novalidate="novalidate"
                                    class="needs-validation"
                            >
                                <!-- Effect start date -->
                                <div class="form-group">
                                    <label for="effect-start-date"
                                           class="required-field-asterisks"
                                    >Date d'entrée en vigueur</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                                    <span class="input-group-text">
                                                        <i class="far fa-calendar-alt"></i>
                                                    </span>
                                        </div>
                                        <masked-input type="text"
                                                      id="effect-start-date"
                                                      mask="11/11/1111"
                                                      class="form-control float-right"
                                                      :class="{ 'is-invalid': $v.formData.effectStartDate.$error }"
                                                      @input="maskedDelayTouch($v.formData.effectStartDate)"
                                                      v-model="formData.effectStartDate"
                                        />
                                    </div>
                                    <FormError error="Format de date incorrect"
                                               v-if="!$v.formData.effectStartDate.validDate && $v.formData.effectStartDate.$dirty"
                                    ></FormError>
                                    <FormError error="Veuillez renseigner la date "
                                               v-if="!$v.formData.effectStartDate.required && $v.formData.effectStartDate.$dirty"
                                    ></FormError>
                                    <FormError error="L'année indiquée n'est pas correcte"
                                               v-if="!$v.formData.effectStartDate.isValidDateYear && $v.formData.effectStartDate.$dirty"
                                    ></FormError>
                                    <FormError error="La date d'entrée en vigueur de la DUE doit être égale ou
                                                      antérieure à la date de prise d'effet du contrat d’assurance.
                                                      Le cas échéant pour pouvoir modifier cette date, veuillez
                                                      modifier d'abord la date de prise d'effet du contrat d'assurance
                                                      sur l'étape 6, puis revenez sur l'étape 3 pour modifier la date
                                                      d'entrée en vigueur de la DUE. "
                                               v-if="!$v.formData.effectStartDate.dateSameOrBeforeDate && $v.formData.effectStartDate.$dirty"
                                    ></FormError>
                                    <p v-if="legalInformation"
                                       class="input-legend"
                                    >{{ legalInformation.effectStartDate.legalAdvice }}</p>
                                </div>
                                <!-- Effect start date -->

                                <!-- Years to review -->
                                <div class="form-group">
                                    <label class="required-field-asterisks"
                                           for="years-to-review"
                                    >Date de réexamen envisagée à l'issue d'une période de</label>
                                    <select id="years-to-review"
                                            class="form-control select2"
                                            v-model.number="formData.yearsToReview"
                                    >
                                        <option :value="1">1 an</option>
                                        <option :value="2">2 ans</option>
                                        <option :value="3">3 ans</option>
                                        <option :value="4">4 ans</option>
                                        <option :value="5">5 ans</option>
                                    </select>
                                    <p v-if="legalInformation"
                                       class="input-legend"
                                    >{{ legalInformation.yearsToReview.legalAdvice }}</p>
                                </div>
                                <!-- Years to review -->

                            </form>
                        </div>
                    </div>

                    <div class="input-group col-md-10 mx-sm-auto my-md-4">
                        <div class="mx-sm-auto">
                            <button class="btn btn-lg btn-link btn__primary"
                                    :disabled="saveIsLoading || nextStepIsLoading"
                                    @click.prevent="toPreviousStep('due-third-step')"
                            >
                                <span>Revenir à l'étape précédente</span>
                            </button>

                            <button class="btn btn-success btn-lg ml-4 btn-link btn__save"
                                    :disabled=" saveIsLoading || nextStepIsLoading"
                                    @click.prevent="saveDue()"
                            >
                                <span>Enregistrer le brouillon</span>
                                <ButtonSpinner :isLoading="saveIsLoading"></ButtonSpinner>
                            </button>
                        </div>
                    </div>

                    <div class="input-group mx-sm-auto">
                        <div class="large-btn__box">
                            <button class="btn btn-success btn-lg btn-link btn__save--large"
                                    :disabled="$v.$invalid || saveIsLoading || nextStepIsLoading"
                                    @click.prevent="saveAndMoveForward('due-fifth-step')"
                            >
                                <span>Enregistrer les modifications</span>
                                <ButtonSpinner :isLoading="nextStepIsLoading"></ButtonSpinner>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Sidebar from '../../../components/Sidebar';
    import Footer from '../../../components/Footer'
    import ButtonSpinner from '../../../components/ButtonSpinner';
    import ValidationDelayTouch from '../../../mixins/validationDelayTouch';
    import MaskedInput from 'vue-masked-input';
    import DueFourthStepManager from '../../../service/manager/due/fourthStepManager';
    import FormError from '../../../components/FormError';
    import DueStepsNavigation from '../../../mixins/dueStepsNavigation';
    import Header from '../../../components/Header';
    import { mapActions, mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import {
      validDateConstraint,
      isValidDateYearConstraint,
      dateSameOrBeforeDateConstraint
    } from '@/utils/validation';

    export default {
        mixins: [ValidationDelayTouch, DueStepsNavigation],
        data() {
            return {
                formData: {
                    effectStartDate: '',
                    yearsToReview: null
                },
                saveIsLoading: false,
                nextStepIsLoading: false,
                contractStartDate: null
            };
        },
        computed: {
        ...mapGetters({
                currentStep: 'currentStep',
                due: 'due',
                legalInformation: 'legalInformation',
            })
        },
        async created() {
            await this.fetchDue();
            await this.fetchDueLegalInformation();
            await this.setCurrentStep(4);
        },
        methods: {
            ...mapActions({
                setCurrentStep: 'setCurrentStep',
                fetchCurrentDue: 'fetchCurrentDue',
                updateCurrentDue: 'updateCurrentDue',
                fetchDueLegalInformation: 'fetchDueLegalInformation'
            }),
            async fetchDue() {
                await this.fetchCurrentDue(this.$route.params.id);
                this.formData = {
                    ...this.formData,
                    ... await DueFourthStepManager.createFormDataFromResponse(this.due)
                };
                this.contractStartDate = this.due.contractStartDate !== 'undefined' ? this.due.contractStartDate : null;
            },
            async prepareRequest() {
                return await DueFourthStepManager.createFourthStepUpdateRequest(this.formData);
            },
        },
        validations() {
            return {
                formData: {
                    effectStartDate: {
                        required,
                        validDate: validDateConstraint,
                        isValidDateYear: isValidDateYearConstraint,
                        dateSameOrBeforeDate: dateSameOrBeforeDateConstraint(this.contractStartDate)
                    },
                    yearsToReview: {
                        required
                    }
                }
            }
        },
        components: {
            Header,
            Footer,
            Sidebar,
            ButtonSpinner,
            MaskedInput,
            FormError
        }
    }
</script>